import { useContext, useEffect, useState } from "react";
import { ToolContext } from "../../../../../../core/context/ToolContext";
import { JoyrideWrapper } from "../../JoyrideWrapper";

export const BookingBooked = ({ end }) => {
	const {personalization_state} = useContext(ToolContext)
	const {walkthrough, startHere} = personalization_state
	const [firstStepReady, setFirstStepReady] = useState(false);
	const tab = new URLSearchParams(window.location.search).get('tab')

	const endTour = ()=>{
		walkthrough.set((p) => ({ ...p, bookingBooked: false}))
		startHere.set((p) => ({ ...p, show: true}))
		setFirstStepReady(false)
	}

	const steps = [
		{
			target: '.bookingBookedFirstStep',
			title: "View Order",
			content: 'Click to view booking details.',
			disableBeacon: true,
			placement: "left",
		},
		{
			target: '.bookingBookedSecondStep',
			title: "Move to Check-In",
			content: 'Click to move this booking to check-in.',
			disableBeacon: true,
			placement: "left",
			modalTriggers: 'bookingBooked'
		},
	]

	useEffect(() => {
		const interval = setInterval(() => {
			const el = document.querySelector('.bookingBookedFirstStep');
			if (el) {
				clearInterval(interval);
				setFirstStepReady(true);
			}
		}, 100);
		return () => clearInterval(interval);
	}, [tab, walkthrough.data.bookingBooked]);

	return (
		firstStepReady && 
		<JoyrideWrapper 
			run={Boolean(walkthrough.data.bookingBooked)} 
			steps={steps} 
			setter={endTour} 
			end={end}
			p_name="bookingBooked" 
			featureName="sales"
		/>
	);
}
